import React, {Component} from 'react';
import {observer} from 'mobx-react';

import Field from 'lib/struct/form/fields/Field';
import Select from 'lib/struct/form/Select';
import SpanLink from 'lib/struct/span_link/SpanLink';
import IconBox from 'lib/struct/icon/IconBox';
import Icon from 'lib/struct/icon/Icon';

import styles from './MarkupStyleThemeStorefrontSelect.less';

@observer export default class MarkupStyleThemeStorefrontSelect extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;

		const storefront_options = context.style_theme_storefront_options;

		return (
			<div>
				<Field label='Тема дизайна'>
					<Select
						options={context.style_theme_options}
						value={context.current_style_theme_id}
						onChange={e => context.updateCurrentStyleTheme(e.target.value)}
						disabled={context.markup_styles_is_in_loading}
					/>
				</Field>

				{
					storefront_options.length > 1 ? (
						<Field label='Витрина'>
							<Select
								options={context.style_theme_storefront_options}
								value={context.current_style_storefront}
								onChange={e => context.updateCurrentStyleThemeStorefront(e.target.value)}
								disabled={context.markup_styles_is_in_loading}
							/>

							{
								context.isCurrentMarkupStyleStorefrontWithPersonal() ? (
									<SpanLink
										onClick={() => context.resetCurrentMarkupStyleSettings()}
										className={styles['reset-settings__block']}
									>
										<IconBox
											icon={(<Icon name='rotate-left' />)}
											className={styles['reset-settings__icon-block']}
										>
											Сбросить настройки для витрины
										</IconBox>
									</SpanLink>
								) : (null)
							}
						</Field>
					) : (null)
				}
			</div>
		);
	}
}